import { render, staticRenderFns } from "./quick-start.page.vue?vue&type=template&id=e4fb2252&scoped=true&"
import script from "./quick-start.page.vue?vue&type=script&lang=js&"
export * from "./quick-start.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fb2252",
  null
  
)

export default component.exports